import { Injectable, OnDestroy } from "@angular/core";
import { IxellAPIService } from "./api.service";

@Injectable()
export class ErrorService implements OnDestroy {

    errorLogSub:any;
    constructor(private apiService: IxellAPIService) {}

    ngOnDestroy(){
        if (this.errorLogSub != null) this.errorLogSub.unsubscribe();
    }

  setErrorLog(code: string, desc: string, param: string, date: string) {
        this.errorLogSub = this.apiService.errorLog(code, desc, param).subscribe(data => {
            if(data){
                if (this.errorLogSub != null) this.errorLogSub.unsubscribe();
            }
        }, error => {
            console.log(error);
        })
    }

}
